import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { colors, HealtheraButton } from '../../../../../../healtheraComponents';

const AddNoteComponent = ({ handleSubmit, isFetching, handleGoToList }) => {
  const { user: { forename, surname } = {} } = useSelector((state) => state.authentication);
  const [text, setText] = useState('');
  const handleChangeText = (e) => setText(e.target.value);

  return (
    <Container>
      <ModalTitle>
        {forename} {surname} - <ModalText>Add note</ModalText>
      </ModalTitle>
      <FormContainer>
        <Form onSubmit={(e) => handleSubmit(text, e)}>
          <TextArea
            spellCheck={false}
            value={text}
            onChange={handleChangeText}
          />
          <HealtheraButton
            type="submit"
            disabled={!text || isFetching}
            fontWeight="500"
            fontFamily="SFProRegular"
            width="100px"
            height="35px"
          >
            Add note
          </HealtheraButton>
        </Form>
        <CancelButton
          disabled={isFetching}
          type="submit"
          onClick={handleGoToList}
        >
          Cancel
        </CancelButton>
      </FormContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 32px 48px;
  background: #fff;
`;

const TextArea = styled.textarea`
  background-color: ${colors.FADED_LIGHT};
  border: none;
  resize: none;
  border-radius: 8px;
  padding: 16px;
  color: #383847;
  width: 560px;
  box-sizing: border-box;
  height: 160px;
  margin-bottom: 30px;
`;

const ModalTitle = styled.p`
  margin: 0;
  margin-bottom: 16px;
  color: ${colors.DARK};
`;

const ModalText = styled.span`
  color: ${colors.FADED};
`;

const CancelButton = styled.button`
  color: ${colors.HEALTHERA_GREEN};
  border: none;
  background: none;
  cursor: pointer;
  margin-top: 8px;
  font-size: 16px;
`;

const Form = styled.form`
  margin: 0 auto;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export default AddNoteComponent;
